module.exports = __webpack_public_path__ + "assets/img/14@3x.99c99a35.png";